import { SupersededRule } from "@protos/issues/v1/issues";
import { isSupersededBySecrets } from "@shared/utils";

import { useBasePath } from "../useBasePath";

export const useSupersededByRulePathsLink = (
  supersededBy: SupersededRule[]
) => {
  const basePath = useBasePath();
  const rulePaths = supersededBy.map((r) => r.rulePath).join(",");

  const product = isSupersededBySecrets(supersededBy) ? "secrets" : "code";

  // _technically_ you could end up in a situation where you're sending some Code
  // rule paths to Secrets, but this isn't likely to happen and even if it does
  // the Secrets policy page will just ignore them so it's fine
  return `${basePath}/policies/${product}?q=${rulePaths}`;
};
